module.exports = __webpack_public_path__ + "static/media/conference-catering-hero.f1022c12.jpg";